import ModalFooter from "features/shared/components/modal/ModalFooter";
import ModalHeader from "features/shared/components/modal/ModalHeader";
import React from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "features/shared/forms/hooks/useForm";
import FormGroup from "features/shared/forms/components/FormGroup";
import { advanceReasonValidations } from './advanceReasonValidation'
import { useTranslation } from "react-i18next";

interface Props {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: (reason: string) => void;
}

const AdvanceReasonDialog = ({ show, setShow, onSubmit }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // form hook
  const { values, errors, bindField, clearForm, valideteForm } = useForm({
    initialValidations: advanceReasonValidations()
  });

  // handlers
  const submitFormHandler = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (valideteForm()) {
      onSubmit(values["reason"]);
    }
  };

  const closeDialogHandler = () => {
    clearForm();
    setShow(false);
  };

  // render
  return (
    <Modal show={show} onHide={closeDialogHandler}>
      <ModalHeader
        title={tLabels("advanceReasonDialog.reasonReductionAdvances")}
        onCloseClick={closeDialogHandler}
      />
      <form onSubmit={submitFormHandler}>
        <div className="modal-body pt-4">
          <FormGroup
            labelText={tLabels("advanceReasonDialog.reasonReductionAdvances")}
            validationError={errors["reason"]}
          >
            <textarea 
              className="form-control" 
              rows={5} 
              placeholder={tLabels("advanceReasonDialog.setReasonReductionAdvances")}
              maxLength={500}
              {...bindField("reason")} 
            />
          </FormGroup>
        </div>
        <ModalFooter>
          <button type="button" className="btn btn-outline-secondary mr-2" onClick={closeDialogHandler}>{tLabels("advanceReasonDialog.edit")}</button>
          <button type="submit" className="btn btn-primary">{tLabels("advanceReasonDialog.send")}</button>
        </ModalFooter>
      </form>
    </Modal>
  );
}

export default AdvanceReasonDialog;
